'use client';

import { useTranslations } from 'next-intl';
import { Box, HStack, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import { TraderDetailModal } from './TraderDetailModal';
import TouchOpacity from '../ui/TouchableOpacity';

interface StorySectionProps {
  data: {
    description: string;
    address: string;
    nickname: string;
  };
}

export function StorySection({ data }: StorySectionProps) {
  const t = useTranslations();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleExpandPress = () => {
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  return (
    <Box w="full" px={4} flex={1}>
      <TouchOpacity
        borderLeft="2px solid #50D2C1"
        background="rgba(188, 254, 45, 0.10)"
        position="relative"
        px={3}
        py={2}
        h="full"
        onClick={handleExpandPress}
        gap={'2px'}
      >
        <Text fontSize="11px" color="text.t1/60" fontWeight="medium">
          {t('trader.story.aiTitle')} - - {data.nickname}
        </Text>
        <Text
          fontFamily={['NotoSans-Italic', 'sans-serif']}
          fontSize="sm"
          fontStyle="italic"
          color="text.t1/90"
          lineClamp={3}
        >
          {data.description || t('trader.story.noDescription')}
        </Text>

        {/* Expand Button - positioned at bottom right */}
        {/* <HStack
          pos="absolute"
          bottom={1}
          right="2"
          rounded="full"
          px={2}
          py={1}
          pl={4}
          align="center"
          gap={1}
          bg="linear-gradient(90deg, rgba(19, 25, 5, 0.40) 1.25%, #131905 30.14%, #131905 100%);"
        >
          <Text fontSize="sm" color="text.expand" fontWeight="medium">
            {t('trader.stats.expand')}
          </Text>
          <Box color="text.expand" transition="transform 0.2s">
            <FiChevronDown size={18} />
          </Box>
        </HStack> */}
      </TouchOpacity>

      {/* Trader Detail Modal */}
      {/* <TraderDetailModal
        visible={isModalVisible}
        onClose={handleCloseModal}
        data={data}
      /> */}
    </Box>
  );
}
